// seam over window.location writes so tests can mock navigation (jsdom 26 locks window.location)
export const setLocationHref = (url: string): void => {
  window.location.href = url;
};

export const assignLocation = (url: string): void => {
  window.location.assign(url);
};

export const reloadPage = (): void => {
  window.location.reload();
};
